import { render, staticRenderFns } from "./view-layout.vue?vue&type=template&id=4bd16688&scoped=true"
import script from "./view-layout.vue?vue&type=script&lang=js"
export * from "./view-layout.vue?vue&type=script&lang=js"
import style0 from "./view-layout.vue?vue&type=style&index=0&id=4bd16688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd16688",
  null
  
)

export default component.exports